var chunkToChildrenMap = {"3987":["6718"],"4413":["6718"]};
__webpack_require__.f.prefetch = (chunkId, promises) => {
  Promise.all(promises).then(() => {
    var chunks = chunkToChildrenMap[chunkId];
    Array.isArray(chunks) && chunks.map(__webpack_require__.E);
  });
};